import $ from "jquery";
import setAppLinksParams from "scripts/components/setAppLinksParams";
import { GAPageView } from "scripts/components/ga/page_view";
import header from "../components/header";
import wishlist from "../components/wishlist/wishlist";
import inputSearch from "../components/inputSearch";
import response from "../components/response";
import collections from "../components/collections";
import forms from "../components/forms";
import modals from "../components/listing/modals";
import tooltip from "../components/tooltip";
import { initSupport } from "scripts/components/support/support";
import { initLazyLoadingRecaptcha } from "scripts/components/recaptcha/recaptcha";
import { installGoogleTranslateShim } from "scripts/utils/googleTranslateShim";

installGoogleTranslateShim();

global.$ = global.jQuery = $;

document.addEventListener("DOMContentLoaded", () => {
  GAPageView();
  header();
  inputSearch();
  response();
  collections();
  forms();
  modals();
  wishlist();
  tooltip();

  setAppLinksParams();
  initSupport();
  initLazyLoadingRecaptcha();

  if ($(".block-seo").length) {
    const seoContentHeight = $(".js_seo_content").height();
    if (seoContentHeight < 170) {
      $(".js_seo_container").css("max-height", "none");
      $(".js_seo_toggles").hide();
      return;
    }
    const wrapper = $(".block-seo .wrapper:not(.opener-holder)");
    const height = wrapper.height();
    const realHeight = wrapper.prop("scrollHeight");

    if (realHeight < height) {
      $(".block-seo .opener-holder").remove();
    }
  }
  $(".block-seo__opener").on("click", function showSeoText() {
    $(this).parents(".block-seo").toggleClass("active");
  });
});
